module.exports = __webpack_public_path__ + "static/media/default_city.8975eca2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/Defaults/default_city.jpg
// module id = 524
// module chunks = 0